export enum BookingKitType {
  Complete = "Complete",
  AccruedIncome = "AccruedIncome",
  AccruedCost = "AccruedCost",
  PreviouslyAccruedIncome = "PreviouslyAccruedIncome",
  PreviouslyAccruedCost = "PreviouslyAccruedCost",
  Credit = "Credit",
  SickPay = "SickPay",
  Compensation = "Compensation"
}
